import {
  Grid,
  GridColumn as Column,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridToolbar
} from "@progress/kendo-react-grid";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import * as React from "react";
import { process } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { useQueryGetEmployeeCensusReport } from "../../data/services/clientService";
import UserContext from "../../layouts/UserContext";
import OEContext from "../../layouts/OEContext";

const EmployeeCensusReport = (clientId) => {
  const navigate = useNavigate();
  const { loggedInUser } = React.useContext(UserContext);
  const oePeriod = React.useContext(OEContext);
  const _grid = React.useRef(undefined);
  const _export = React.useRef(null);

  const [showAllClients, setShowAllClients] = React.useState("Yes");
  const [allClientOption, setAllClientOption] = React.useState("All Clients");
  const [clientListSrc, setClientListSrc] = React.useState([]);
  const [clientMasterList, setClientMasterList] = React.useState([]);
  const [gridDataState, setGridDataState] = React.useState({
    take: 20,
    skip: 0,
  });
  const pagerSetting = {
    buttonCount: 5,
    info: true,
    type: "numeric",
    pageSizes: [10, 20, 50, 100, 200, 500],
    previousNext: true,
  };

  const { isLoading: clientListLoading, data: clientList } = useQueryGetEmployeeCensusReport(
    oePeriod?.oePeriodId,
    clientId?.clientId || loggedInUser?.clientId || "0"
  );

  React.useEffect(() => {
    if (!clientListLoading && clientList && clientList.data) {
      setClientMasterList(clientList.data);
      setClientListSrc(process(clientList.data.slice(0), gridDataState));
    }
  }, [clientListLoading, clientList, gridDataState]);

  React.useEffect(() => {
    if (loggedInUser && !loggedInUser.isWhiteListed) {
      navigate("/under-maintenance");
    }
  }, [loggedInUser, navigate]);

  if (clientListLoading) {
    return <LoadingIndicator />;
  }

  const onClientFilterChange = (event) => {
    setShowAllClients(event.value === "All Clients" ? "Yes" : "No");
    setAllClientOption(event.value);
  };

  const RenderGrid = () => {
    

    const dataStateChange = (event) => {
      setClientListSrc(process(clientMasterList.slice(0), event.dataState));
      setGridDataState(event.dataState);
    };

    const columnMenuHeader = (field) => {
      var active = GridColumnMenuFilter.active(field, gridDataState.filter);
      return active ? "active" : "";
    };

    const ColumnCheckboxMenu = (props) => {
      return (
        <div>
          <GridColumnMenuCheckboxFilter
            {...props}
            data={clientMasterList}
            expanded={true}
          />
        </div>
      );
    };


    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save(clientList, _grid.current.columns);
        }
    };
    return (
   
      <ExcelExport ref={_export} fileName="employee_census_report.xlsx" >
        <div style={{ fontWeight: "bold", textAlign: "center", display: "flex", justifyContent: "center", marginBottom: 10 }}>
          Employee Census Report
          </div>
        <Grid
          sortable={true}
          pageable={pagerSetting}
          pageSize={20}
          data={clientListSrc}
          {...gridDataState}
          onDataStateChange={dataStateChange}
          ref={_grid}
        >
          <GridToolbar>
                  <ButtonGroup>
                      <Button themeColor={'base'} onClick={excelExport}>
                          Export to Excel
                      </Button>
                  </ButtonGroup>
              </GridToolbar>
        
          <Column
            field="employeeName"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("employeeName")}
            title="Employee Name"
          />
          <Column
              field="benefitGroupName"
              filter="text"
              columnMenu={ColumnCheckboxMenu}
              headerClassName={columnMenuHeader("benefitRep")}
              title="Benefit Group Name"
          />
          <Column
              field="planId"
              filter="text"
              columnMenu={ColumnCheckboxMenu}
              headerClassName={columnMenuHeader("salesRepName")}
              title="Plan ID"
          />
          <Column
              field="planDescription"
              filter="text"
              columnMenu={ColumnCheckboxMenu}
              headerClassName={columnMenuHeader("planDescription")}
              title="Plan Description"
          />
          <Column
              field="status"
              filter="text"
              columnMenu={ColumnCheckboxMenu}
              headerClassName={columnMenuHeader("status")}
              title="Status"
          />
          <Column
            field="planType"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("planType")}
            title="Plan Type"
          />
          <Column
            field="premiumAmount"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("premiumAmount")}
            title="Premium Amount"
          />
          <Column
            field="companyContribution"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("companyContribution")}
            title="Company Contribution"
          />
          <Column
            field="employeeContributionAmount"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("employeeContributionAmount")}
            title="Employee Contribution Amount"
          />
          <Column
            field="employeeState"
            filter="text"
            columnMenu={ColumnCheckboxMenu}
            headerClassName={columnMenuHeader("employeeState")}
            title="Employee State"
          />
        </Grid>
      </ExcelExport>
    );
  };

  if (clientMasterList.length === 0 && showAllClients !== "No") {
    return (
      <div
        style={{
          backgroundColor: "#cce5ff",
          marginTop: 20,
          padding: 10,
          borderRadius: ".25rem",
          textAlign: "center",
        }}
      >
        <span style={{ color: "#004085" }}>
          No Employee Census Data Available  </span>
      </div>
    );
  }

  return (
    <div>

      <div
        style={{
          justifyContent: "space-around",
          display: "flex",
          paddingBottom: 20,
          marginTop: "20px",
        }}
      >
        <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>

          {loggedInUser.benefitAdminPrivilege && (
            <DropDownList
              style={{
                width: "150px",
                marginLeft: "10px",
              }}
              data={["All Clients", "My Clients"]}
              defaultValue={allClientOption}
              onChange={onClientFilterChange}
            />
          )}
        </div>
      </div>
      {RenderGrid()}
    </div>
  );
};

export default EmployeeCensusReport;
